import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var DropDownOptions = require("components/utility/DropDownOptions");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

@connect(
	(state, props) => {
		var refPrefs = {}

		// USER IS A TEACHER
		if (CurrentUser.isTeacherAdmin()) {
			var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
			if (admin && admin.prefs) {
				refPrefs = admin.prefs;
			}
		} else {
			// USER IS DISTRICT ADMIN
			if (CurrentUser.isDistrictAdmin()) {
				var selectedOrgs = RosterSelectors.districtOrgs({
					state, conditions: { ids: [CurrentUser.get().primary_district_org_id] }
				})
			} else {
				// USER IS SCHOOL ADMIN
				var selectedOrgs = RosterSelectors.schoolOrgs({
					state, conditions: { ids: [CurrentUser.get().primary_school_org_id] }
				})
			}

			if (selectedOrgs.length > 0) {
				refPrefs = selectedOrgs[0].prefs
			}
		}

		return {
			refPrefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            if (CurrentUser.isDistrictAdmin()) {
            	return Promise.all([ dispatch(RosterActions.fetchDistrictOrgs({
	                filters:{ids: [CurrentUser.get().primary_district_org_id]}, 
	                embeds:['district_org.prefs'],
	                cache: true
	            }))])
            } else if (CurrentUser.isSchoolAdmin()) {
            	return Promise.all([ dispatch(RosterActions.fetchSchoolOrgs({
	                filters:{ids: [CurrentUser.get().primary_school_org_id]}, 
	                embeds:['school_org.prefs'],
	                cache: true
	            }))])
            } else {
            	return Promise.all([ dispatch(RosterActions.fetchAdmins({
	                filters:{ids: [CurrentUser.get().id]}, 
	                embeds:['user.prefs'],
	                cache: true
	            }))])
            }
            return Promise.all([])
        },

		onChange: (prefsUpdate, message) => {
			// Will get moved to redux at some point (soon, I hope)
			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			if (CurrentUser.isDistrictAdmin()) {
				return dispatch(RosterActions.updateDistrictOrgPrefs({
					currentUserID: CurrentUser.get().id,
					districtOrgID: CurrentUser.get().primary_district_org_id,
					resetPrefs: true,
					update: prefsUpdate
				}))
			} else if (CurrentUser.isSchoolAdmin()) {
				return dispatch(RosterActions.updateSchoolOrgPrefs({
					currentUserID: CurrentUser.get().id,
					resetPrefs: true,
					schoolOrgID: CurrentUser.get().primary_school_org_id,
					update: prefsUpdate
				}))
			} else {
				return dispatch( RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: true,
					update: prefsUpdate
				}))
			}
		}
	})
)

@providePopulateData({waitForLoad:true})
class SchoolYearMonthsPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	selectSchoolYearStart() {
		var selectedStartMonth = this.refs.school_year_start_input.value - 1;
		var preferenceHash = { school_year_start_month: selectedStartMonth }
		this.props.onChange(preferenceHash, "You changed the start of your school year");
	}

	selectSchoolYearEnd() {
		var selectedEndMonth = this.refs.school_year_end_input.value - 1;
		var preferenceHash = { school_year_end_month: selectedEndMonth }
		this.props.onChange(preferenceHash, "You changed the end of your school year");		
	}

	renderOrgPreference() {
		var org_prefs = CurrentUser.get().org_prefs;
		
		// ONLY SHOW TO TEACHERS AND SCHOOL ADMINS THAT ARE PART OF A DISTRICT
		if (!_.isEmpty(org_prefs) && !(CurrentUser.isDistrictAdmin() || (CurrentUser.isSchoolAdmin() && !CurrentUser.get().primary_district_org_id))) {
			var currentSchoolYearStart = CurrentUser.get().org_prefs.school_year_start_month;
			var currentSchoolYearEnd = CurrentUser.get().org_prefs.school_year_end_month;

			return (
				<div className="orgPreferences">
					<b>Your Administrator chose the following dates: {MONTHS[currentSchoolYearStart]} - {MONTHS[currentSchoolYearEnd]}</b>
				</div>
			)
		}
	}

	render() {
		var currentSchoolYearStart = CurrentUser.get().prefs.school_year_start_month + 1;
		var currentSchoolYearEnd = CurrentUser.get().prefs.school_year_end_month + 1;

		return (
			<div className="schoolYearContainer">
				<p>
					Your students' progress will be calculated based on when your school year starts and ends.
				</p>
				{ this.renderOrgPreference() }
				<label>
					<span>Start</span>
					<select type="text" className="form-control month" ref="school_year_start_input"
						defaultValue={ currentSchoolYearStart } onChange={ this.selectSchoolYearStart } >
						{ DropDownOptions.Select.Months({ monthNameOnly: true }) }
					</select>
				</label>
				<label>
					<span>End</span>
					<select type="text" className="form-control month" ref="school_year_end_input"
						defaultValue={ currentSchoolYearEnd } onChange={ this.selectSchoolYearEnd } >
						{ DropDownOptions.Select.Months({ monthNameOnly: true }) }
					</select>
				</label>
			</div>
		)
	}

}

var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul','Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

SchoolYearMonthsPreference.WrappedComponent.propTypes = StrictPropTypes({
	onChange: PropTypes.func.isRequired,
	populateData: PropTypes.func.isRequired,
	refPrefs: PropTypes.object.isRequired
});

module.exports = SchoolYearMonthsPreference;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/SchoolYearMonthsPreference.js